
import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

export const useCategoryName = (categoryId?: string, instanceId?: string) => {
  const [categoryName, setCategoryName] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!categoryId) {
      setCategoryName(undefined);
      return;
    }
    
    let isCancelled = false;
    
    const fetchCategoryName = async () => {
      try {
        console.log(`[useMarkupCalculation:${instanceId}] Fetching category name for ID:`, categoryId);
        const { data, error } = await supabase
          .from('supplier_categories')
          .select('name')
          .eq('id', categoryId)
          .maybeSingle();
          
        if (error && error.code !== 'PGRST116') {
          console.error(`[useMarkupCalculation:${instanceId}] Error fetching category name:`, error);
          return;
        }
        
        if (!isCancelled) {
          console.log(`[useMarkupCalculation:${instanceId}] Category name fetched:`, data?.name);
          setCategoryName(data?.name);
        }
      } catch (err) {
        if (!isCancelled) {
          console.error(`[useMarkupCalculation:${instanceId}] Error fetching category name:`, err);
          setCategoryName(undefined);
        }
      }
    };
    
    fetchCategoryName();
    
    return () => {
      isCancelled = true;
    };
  }, [categoryId, instanceId]);

  return categoryName;
};
